import { Component, OnInit } from '@angular/core';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private ecoDocsTitleService: EcoDocsTitleService) { }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle('Page Not Found', true);
    console.log('404');
  }

}
